import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh/index'
import tw from './tw/index'
import { getStore } from '@/utils'

Vue.use(VueI18n) // 全局挂载

const urlParams = new URLSearchParams(window.location.search)
const query = urlParams.get('locale')

export default new VueI18n({
  locale: query || getStore('locale') || 'zh', // 从localStorage中获取 默认中文
  messages: {
    zh: zh, // 中文语言包
    tw: tw // 香港繁体语言包
  }
})
